<template>
  <div class="mb-4 w-full">
    <div class="mb-2 flex justify-center">
      <div class="w-32 h-32 rounded-full bg-gray-500 flex items-center justify-center overflow-hidden border-2 border-gray-500">
        <img v-if="getCurrentAvatar" :src="getCurrentAvatar.image" alt="" class="w-full h-full rounded-full">
        <span v-else class="text-base" style="color:#a0aebf">Choose avatar</span>
      </div>
    </div>
    <div class="overflow-hidden w-full text-left px-2 no-scroll">
      <div class="overflow-x-auto flex items-center overflow-hidden space-x-3 no-scroll">
        <label :for="`avatar-${avatar.id}`" v-for="avatar in avatars" :key="avatar.id"
          class="w-12 h-12 overflow-hidden rounded-full bg-gray-500 flex-shrink-0 cursor-pointer border border-white"
        >
          <img :src="avatar.image" class="w-full h-full rounded-full" alt="">
          <input
            v-bind="$attrs"
            :value="avatar.id"
            :name="name"
            type="radio"
            class="hidden"
            :id="`avatar-${avatar.id}`"
            @input="$emit('input', $event.target.value)"
            >
        </label>
      </div>
      <span
        class="block mt-2 ml-4 text-left"
        v-if="message"
        v-text="message"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: 'BaseAvatar',
   props: {
    name: String,
    message: String,
    inputClass: String,
    readonly: Boolean,
    value: [String, Number]
  },
  computed:{
    ...mapState("profile", ["avatars"]),
    getCurrentAvatar(){
      return this.value ? this.avatars.find(avatar => avatar.id === +this.value) : null
    }
  },
  mounted(){
    this.fetchAvatars()
  },
  methods:{
    ...mapActions("profile", ["fetchAvatars"]),
  }
};
</script>
<style scoped>
.no-scroll::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scroll {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
</style>
